import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../../auth/jwt.service';
import { DataSharingService } from '../../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendordashboardService {

  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }

  getVendorData(userId) {
    var data = {
      currentUserId: userId
    }
    return this.http.post(this.rootUrl + '/api/VendorDashboard/getVendorData', data);

  }

  getVendorEnlistmentSteps(userId) {
    var data = {
      currentUserId: userId
    }
    return this.http.post(this.rootUrl + '/api/VendorDashboard/getVendorEnlistmentSteps', data);
  }
  getMessageCount(userId) {
    var data = {
      currentUserId: userId
    }
    return this.http.post(this.rootUrl + '/api/VendorDashboard/getMessageCount', data);

  }
  getMessageList(userId) {
    var data = {
      currentUserId: userId
    }
    return this.http.post(this.rootUrl + '/api/VendorDashboard/getMessageList', data);
  }
  getPendingTasts(userId) {

    var data = {
      currentUserId: userId
    }

    return this.http.post(this.rootUrl + '/api/VendorDashboard/getPendingTasks', data);
  }
  markAsRead(id) {
    var msg = {
      msgId: id
    }
    return this.http.post(this.rootUrl + '/api/VendorDashboard/markAsRead', msg);
  }

  GetVendorsList() {
    return this.http.get(this.rootUrl + '/api/VendorDashboard/GetVendorsList');
  }
  deletemessage(userId){
    debugger;
    const msg = {
      id: userId
    }
    return this.http.post(this.rootUrl + '/api/VendorDashboard/deletemessage', msg);
  }
}
